import React from "react";
import CommonModal from "../../../components/Common/CommonModal";
import PropTypes from "prop-types";
import CommonButton from "../../../components/buttons/CommonButton";
import CommonSwal from "../../../components/Swal/commonSwal";
import TabContent from "../../../components/Tab/TabContent";
import StepsList from "../../../components/steps/StepsList";
import StepsButton from "../../../components/steps/StepsButton";
import TabPane from "../../../components/Tab/TabPane";
import CommonInput from "../../../components/forms/CommonInput";
import {
  handleChange,
  handleChangeNameValue,
  handleChangeNumeral,
  handleChangeUnmask,
} from "../../../helpers/handleFormChanges";
import CommonInputMask from "../../../components/forms/CommonInputMask";
import CommonSelect from "../../../components/forms/CommonSelect";
import CommonInputDecimal from "../../../components/forms/CommonInputDecimal";

function ProcessoBpoModal({
  modalHook,
  valuesHook,
  cepApi,
  servicos,
  salvarProcesso,
}) {
  const { values, setValues } = valuesHook;
  const { processoBpoModal, setProcessoBpoModal } = modalHook;
  const { getCep, cepResponse } = cepApi;

  //Busca dados do CEP
  React.useEffect(() => {
    if (!values?.cep || values?.cep.length !== 8) return;
    try {
      getCep(values.cep);
    } catch (e) {
      CommonSwal({
        title: "Oops!",
        text: "Ocorreu algum erro inesperado, se o problema persistir entre em contato com o suporte Orangiuz",
        icon: "error",
      });
    }
  }, [getCep, values.cep]);

  //Define o retorno da api nos valores dos campos
  React.useEffect(() => {
    if (!cepResponse) return;
    setValues((values) => ({
      ...values,
      logradouro: cepResponse.logradouro,
      bairro: cepResponse.bairro,
      cidade: cepResponse.localidade,
      uf: cepResponse.uf,
      codigo_cidade: cepResponse.ibge,
    }));
  }, [cepResponse, setValues]);

  return (
    <CommonModal
      title="Editar dados"
      is_open_modal={processoBpoModal}
      set_is_open_modal={setProcessoBpoModal}
      size="xl"
      buttons={
        <CommonButton
          key={`novo-processo`}
          color="success"
          onClick={salvarProcesso}
        >
          Salvar
        </CommonButton>
      }
    >
      <StepsList>
        <StepsButton href="dadosEmpresa" step={1} ativo>
          Dados da empresa
        </StepsButton>
        <StepsButton href="dadosTributacao" step={2}>
          Dados de tributação
        </StepsButton>
      </StepsList>
      <TabContent>
        <TabPane id="dadosEmpresa" ativo>
          <div className="row">
            <div className="col-lg-3 mb-3">
              <CommonInput
                label="Nome"
                id="razao_social"
                value={values.razao_social}
                onChange={(e) => {
                  handleChange(e, values, setValues);
                }}
                required
              />
            </div>
            <div className="col-lg-3 mb-3">
              <CommonInputMask
                label="CNPJ"
                id="cnpj"
                value={values.cnpj}
                onChange={(e) => handleChangeUnmask(e, values, setValues)}
                mask="99.999.999/9999-99"
                required
                disabled
              />
            </div>
            <div className="col-lg-3 mb-3">
              <CommonInput
                label="Alias do E-mail"
                id="alias_email"
                value={values.alias_email}
                onChange={(e) => {
                  handleChange(e, values, setValues);
                }}
                required
              />
              <small>Não utilizar espaços</small>
            </div>
            <div className="col-lg-3 mb-3">
              <CommonInput
                label="Complemento Título"
                id="complemento_titulo"
                value={values.complemento_titulo}
                onChange={(e) => {
                  handleChange(e, values, setValues);
                }}
                required
              />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-3 mb-3">
              <CommonInput
                label="Logomarca"
                id="logo_empresa"
                value={values.logo_empresa}
                onChange={(e) => {
                  handleChange(e, values, setValues);
                }}
              />
            </div>
            <div className="col-lg-3 mb-3">
              <CommonInput
                label="Altura da logo (px)"
                id="height_logo"
                value={values.height_logo}
                onChange={(e) => {
                  handleChangeNumeral(e, values, setValues);
                }}
                required
              />
            </div>
            <div className="col-lg-3 mb-3">
              <CommonInput
                label="Largura da logo (px)"
                id="width_logo"
                value={values.width_logo}
                onChange={(e) => {
                  handleChangeNumeral(e, values, setValues);
                }}
                required
              />
            </div>
            <div className="col-lg-3 mb-3">
              <CommonInput
                label="Cor do E-mail"
                id="color_hex"
                value={values.color_hex}
                onChange={(e) => handleChange(e, values, setValues)}
                type="color"
                style={{ maxWidth: "3rem", padding: ".47rem" }}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-3 mb-3">
              <CommonInputMask
                mask="99999-999"
                label="CEP"
                id="cep"
                value={values.cep}
                onChange={(e) => handleChangeUnmask(e, values, setValues)}
                required
              />
            </div>
            <div className="col-lg-5 mb-3">
              <CommonInput
                label="Logradouro"
                id="logradouro"
                value={values.logradouro}
                onChange={(e) => handleChange(e, values, setValues)}
                required
              />
            </div>
            <div className="col-lg-1 mb-3">
              <CommonInput
                label="N°"
                id="numero"
                value={values.numero}
                onChange={(e) => handleChangeNumeral(e, values, setValues)}
                required
              />
            </div>
            <div className="col-lg-3 mb-3">
              <CommonInput
                label="Complemento"
                id="compl"
                value={values.compl}
                onChange={(e) => handleChange(e, values, setValues)}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 mb-3">
              <CommonInput
                label="Bairro"
                id="bairro"
                value={values.bairro}
                onChange={(e) => handleChange(e, values, setValues)}
                required
              />
            </div>
            <div className="col-lg-4 mb-3">
              <CommonInput
                label="Cidade"
                id="cidade"
                value={values.cidade}
                onChange={(e) => handleChange(e, values, setValues)}
                required
                disabled
              />
            </div>
            <div className="col-lg-1 mb-3">
              <CommonInput
                label="UF"
                id="uf"
                value={values.uf}
                onChange={(e) => handleChange(e, values, setValues)}
                required
                disabled
              />
            </div>
          </div>
        </TabPane>
        <TabPane id="dadosTributacao">
          <div className="row">
            <div className="col-lg-4 mb-3">
              <CommonSelect
                label="Item de serviço"
                id="itemListaServicoLC116"
                value={values.itemListaServicoLC116}
                onChange={(e) => {
                  const opcaoSelecionada =
                    e.target.options[e.target.selectedIndex];
                  const itemListaServicoLC116 = e.target.value;
                  const aliquota = opcaoSelecionada?.dataset?.aliquota;
                  const descricaoItemServico =
                    opcaoSelecionada?.dataset?.descricao;

                  setValues((prevValues) => ({
                    ...prevValues,
                    itemListaServicoLC116,
                    aliquota,
                    descricaoItemServico,
                  }));
                }}
                data={
                  servicos &&
                  Object.keys(servicos).map((servicosKey) => ({
                    text: `${servicos[servicosKey].codigo} - ${servicos[servicosKey].descricao}`,
                    id: servicos[servicosKey].codigo,
                    "data-aliquota": servicos[servicosKey].aliquota_padrao,
                    "data-descricao": `${servicos[servicosKey].codigo} - ${servicos[servicosKey].descricao}`,
                  }))
                }
                placeholder="Selecione o serviço"
                required
                disabled={Object.keys(servicos).length > 1 ? false : true}
              />
            </div>
            <div className="col-lg-4 mb-3">
              <CommonInput
                label="Codigo de município"
                id="codigoServicoMunicipio"
                value={values.codigoServicoMunicipio}
                onChange={(e) => {
                  handleChange(e, values, setValues);
                }}
              />
            </div>
            <div className="col-lg-4 mb-3">
              <CommonInputDecimal
                label="Alíquota"
                id="aliquotaIss"
                value={values.aliquotaIss}
                onChange={(value) => {
                  handleChangeNameValue(
                    "aliquotaIss",
                    value.floatValue,
                    values,
                    setValues
                  );
                }}
                required
              />
            </div>
          </div>
        </TabPane>
      </TabContent>
    </CommonModal>
  );
}

ProcessoBpoModal.propTypes = {
  modalHook: PropTypes.shape({
    processoBpoModal: PropTypes.bool.isRequired,
    setProcessoBpoModal: PropTypes.func.isRequired,
  }).isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  cepApi: PropTypes.object.isRequired,
  servicos: PropTypes.array.isRequired,
  salvarProcesso: PropTypes.func.isRequired,
};

export default ProcessoBpoModal;
